module.exports = __webpack_public_path__ + "static/media/goblin_chief.b71593aa.svg";